import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowCircleRight,
  faCircleNotch,
} from "@fortawesome/free-solid-svg-icons";
import axios from "../../config/axiosConfig";
import { Alert, Snackbar } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { useNavigate } from "react-router-dom";
import PWAPrompt from "react-ios-pwa-prompt";

export const Login = () => {
  const [email, setEmail] = React.useState("");
  const [otp, setOtp] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [showOtp, setShowOtp] = React.useState(false);
  const [showPassword, setShowPassword] = React.useState(false);
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const navigate = useNavigate();

  const handleCheckEmail = async () => {
    try {
      setIsLoading(true);
      const response = await axios.post("/auth/check-email", {
        email: email.toLowerCase().trim(),
      });
      if (response?.data?.status === "success") {
        setIsLoading(false);
        setShowOtp(true);
        setShowPassword(true);
        try {
          await axios.post("/auth/request-otp", {
            email,
          });
        } catch (error) {
          console.log(error);
        }
      }
    } catch (error) {
      //  if 400 error
      console.log(error);
      if (error?.response?.status === 400) {
        setIsLoading(false);
        setShowPassword(true);
      }
    }
  };

  const handleLogin = async () => {
    try {
      setIsLoading(true);
      const response = await axios.post("/auth/login", {
        email: email.toLowerCase().trim(),
        password,
      });

      if (response.data.status === "success") {
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("user", JSON.stringify(response.data.user));
        navigate("/home");
      }
    } catch (error) {
      setOpenSnackbar(true);
    }
    setIsLoading(false);
  };

  const handleRegister = async () => {
    try {
      setIsLoading(true);
      const response = await axios.post("/auth/register", {
        name: email.split("@")[0],
        email: email.toLowerCase().trim(),
        password,
        otp,
      });
      if (response.data.status === "success") {
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("user", JSON.stringify(response.data.user));
        navigate("/home");
      }
    } catch (error) {
      setOpenSnackbar(true);
    }
    setIsLoading(false);
  };

  return (
    <div className="h-screen flex flex-col items-center justify-end bg-login-background bg-cover ">
      <div className="mb-8 text-[0.9rem]">
        {/* Email Input */}
        <div className="w-[95vw] relative border-2 rounded-[50px] overflow-hidden bg-white px-6 py-3 mb-3">
          <p className="text-xs text-black mb-2 mt-2">Get started with email</p>
          <input
            type="text"
            placeholder="Enter your email"
            className="w-full focus:outline-0 font-medium"
            onChange={(e) => {
              setEmail(e.target.value);
            }}
          />
          {showOtp || showPassword ? (
            <></>
          ) : (
            <button
              className="rounded-full absolute top-[1.2rem] right-5 aspect-[1] w-[2rem] h-[2rem] "
              onClick={() => {
                if (email) {
                  handleCheckEmail();
                }
              }}
            >
              {isLoading ? (
                <CircularProgress color="inherit" size={30} className="mt-1" />
              ) : (
                <FontAwesomeIcon
                  icon={faArrowCircleRight}
                  color="black"
                  width={40}
                />
              )}
            </button>
          )}
        </div>

        {/* OTP Section */}
        {showOtp && (
          <div className="w-[95vw]  relative border-2 rounded-[50px] overflow-hidden bg-white px-6 py-3 mb-3">
            <p className="text-xs text-black mb-2 mt-2">6-digits passcode</p>
            <input
              type="text"
              placeholder="Enter your code"
              className="w-full focus:outline-0 font-medium"
              onChange={(e) => {
                setOtp(e.target.value);
              }}
            />
          </div>
        )}

        {/* Password Section */}
        {showPassword && (
          <div className="w-[95vw]  relative border-2 rounded-[50px] overflow-hidden bg-white px-6 py-3 mb-3">
            <p className="text-xs text-black mb-2 mt-2">Password</p>
            <input
              type="password"
              placeholder="Enter your password"
              className="w-full focus:outline-0 font-medium"
              onChange={(e) => {
                setPassword(e.target.value);
              }}
            />
            <button
              className="rounded-full absolute  top-[1.2rem] right-5 aspect-[1] w-[2rem] h-[2rem] "
              onClick={() => {
                if (password && otp && email) {
                  handleRegister();
                } else if (password && email) {
                  handleLogin();
                }
              }}
            >
              {isLoading ? (
                <CircularProgress color="inherit" size={30} className="mt-1" />
              ) : (
                <FontAwesomeIcon
                  icon={faArrowCircleRight}
                  color="black"
                  width={40}
                />
              )}
            </button>
          </div>
        )}
      </div>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={() => {
          setOpenSnackbar(false);
        }}
      >
        <Alert
          severity="error"
          onClose={() => {
            setOpenSnackbar(false);
          }}
          sx={{ width: "100%" }}
        >
          Something went wrong
        </Alert>
      </Snackbar>
      <PWAPrompt
        promptOnVisit={1}
        timesToShow={3}
        copyClosePrompt="Close"
        permanentlyHideOnDismiss={false}
        copyTitle="Download NewTou Now"
      />
    </div>
  );
};
